var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRanking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ranking-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.983,
    height: 22,
    viewBox: "0 0 21.983 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_633",
    "data-name": "Grupo 633",
    transform: "translate(0 15.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_632",
    "data-name": "Grupo 632",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1297",
    "data-name": "Trazado 1297",
    d: "M20.692,363.283H15.746a.739.739,0,0,1-.687-.687v-5.015a.688.688,0,0,1,.687-.687h4.809v5.7A2.441,2.441,0,0,0,20.692,363.283Z",
    transform: "translate(-15.059 -356.894)",
    fill: "#ec407a"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_635",
    "data-name": "Grupo 635",
    transform: "translate(6.87 12.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_634",
    "data-name": "Grupo 634",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1298",
    "data-name": "Trazado 1298",
    d: "M173.891,286.8v8.244a.739.739,0,0,1-.687.687h-6.87a.739.739,0,0,1-.687-.687V286.8a.688.688,0,0,1,.687-.687h6.87A.688.688,0,0,1,173.891,286.8Z",
    transform: "translate(-165.647 -286.118)",
    fill: "#ec407a"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_637",
    "data-name": "Grupo 637",
    transform: "translate(16.35 16.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_636",
    "data-name": "Grupo 636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1299",
    "data-name": "Trazado 1299",
    d: "M379.092,377.158v4.122a.739.739,0,0,1-.687.687h-4.946a2.44,2.44,0,0,0,.137-.687v-4.809h4.809A.688.688,0,0,1,379.092,377.158Z",
    transform: "translate(-373.459 -376.471)",
    fill: "#ec407a"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_639",
    "data-name": "Grupo 639",
    transform: "translate(5.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_638",
    "data-name": "Grupo 638",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1300",
    "data-name": "Trazado 1300",
    d: "M141.714,19.508l-2.267,2.2.55,3.16a.653.653,0,0,1-.275.687.973.973,0,0,1-.756.069l-2.817-1.511-2.817,1.443a.528.528,0,0,1-.687-.069.653.653,0,0,1-.275-.687l.55-3.16-2.336-2.13a.751.751,0,0,1-.137-.687.665.665,0,0,1,.55-.481l3.16-.481,1.374-2.817a.71.71,0,0,1,1.237,0l1.374,2.817,3.16.481a.665.665,0,0,1,.55.481.751.751,0,0,1-.137.687Z",
    transform: "translate(-130.421 -14.682)",
    fill: "#ec407a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRanking);
export default __webpack_public_path__ + "static/media/icon_ranking.90ae24919df504fcf2038390bc0b0287.svg";
export { ForwardRef as ReactComponent };